import {FC} from 'react'
import {InputNumber2} from '../../InputV2'

type Props = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  type?: string
  maxLength?: number
  minLength?: number
  required?: boolean
  labelText?: string
  min?: number
  max?: number
}
const InputNumberWrapper2: FC<Props> = ({
  name,
  disabled,
  textPlaceholder,
  maxLength,
  minLength,
  required,
  labelText,
  type,
  min,
  max,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <InputNumber2
        type={type}
        name={name}
        textPlaceholder={textPlaceholder}
        disabled={disabled}
        maxLength={maxLength}
        minLength={minLength}
        min={min}
        max={max}
      />
    </div>
  )
}

export default InputNumberWrapper2
